var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
// AUTO-GENERATED CONTENT - DO NOT MANUALLY EDIT - Run 'yarn generate:icons' to update
import Icon from '../icon-internal';
function Refresh(_a) {
    var { size } = _a, restProps = __rest(_a, ["size"]);
    return (_jsx(Icon, Object.assign({ viewBox: "0 0 18 18", size: size }, restProps, { children: _jsx("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M11.4 4.6c-.6.2-.8.8-.6 1.4s.8.8 1.4.6l3-1c.4-.2.7-.6.7-1l-.1-2.9c0-.6-.5-1.1-1.1-1.1s-1.1.5-1.1 1.1v.8c-.8-.5-1.6-1-2.6-1.2C6.8 0 2.3 2.5 1 6.8c0 0-.2.8.9 1.1 1 .3 1.2-.5 1.2-.5C3.5 6 4.4 4.8 5.8 4c2.1-1.3 4.8-1.1 6.7.3l-1.1.3zm5.6 5.5s.1-.9-.9-1.1c-1.1-.2-1.2.6-1.2.6-.3 1.4-1.1 2.8-2.4 3.7-2 1.4-4.7 1.4-6.7.2l1-.4c.5-.3.8-.9.5-1.4-.3-.5-.9-.8-1.4-.5L3 12.4c-.4.2-.7.6-.6 1.1l.3 2.9c.1.6.6 1 1.2 1 .6-.1 1-.6 1-1.2l-.1-.8c.8.5 1.7.8 2.6 1 4.4 1 8.7-1.8 9.6-6.3z" }) })));
}
export default Refresh;
